import { render, staticRenderFns } from "./UploadWarehouseTransferAttachment.vue?vue&type=template&id=3287092f&"
import script from "./UploadWarehouseTransferAttachment.vue?vue&type=script&lang=ts&"
export * from "./UploadWarehouseTransferAttachment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3287092f')) {
      api.createRecord('3287092f', component.options)
    } else {
      api.reload('3287092f', component.options)
    }
    module.hot.accept("./UploadWarehouseTransferAttachment.vue?vue&type=template&id=3287092f&", function () {
      api.rerender('3287092f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WarehouseTransfer/UploadWarehouseTransferAttachment.vue"
export default component.exports